import { IExecutiveSummary, IProblemIdentification } from "../../../../app/modules/project/components/ProjectInitiation-steps/core/_models";
import { StoreAction } from "../../../../utils/actions";

/** State type */
interface problemIdentificationDataState {
    problemIdentificationData: IProblemIdentification | null;
}

/** Action type */
interface problemIdentificationDataAction {
    type: string;
    payload: IProblemIdentification;
}

const initialState: problemIdentificationDataState = {
    problemIdentificationData: null
};

export default function problemIdentificationDataReducer(
    state: problemIdentificationDataState = initialState,
    action: problemIdentificationDataAction
): problemIdentificationDataState {

    switch (action.type) {
        case StoreAction.UPDATE_PROBLEM_IDENTIFICATION_DATA:
            return {
                ...state,
                problemIdentificationData: action.payload,
            };
        default:
            return state;
    }
}
